import React, { useState, useEffect } from "react";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

import copyIcon from "../../../../../../../assets/icons/copy-icon.svg";
import ViewGallery from "../../../../../../../shared/components/ViewGallery/ViewGallery";
import { customerDashboardActions } from "../../../../../../../redux/actions/customerDashboard.actions";

const AccessGroupGallery = ({
  myEventsAccessGallery,
  getAccessGroupGallery,
  deleteFromGallery,
  lockFromGallery,
  favoriteClip,
}) => {
  const { t } = useTranslation("common");

  const { eventGroupId } = useParams();

  const [files, setFiles] = useState([]);
  const [selectedFiles, setSelectedFiles] = useState([]);

  const eventUrl = `${window.location.protocol}//${window.location.host}/SharedGallery?groupeventid=${myEventsAccessGallery?.id}`;

  useEffect(() => {
    getAccessGroupGallery(eventGroupId, setFiles);
    // eslint-disable-next-line
  }, []);

  const copyToClipboard = async (e) => {
    e.preventDefault();
    await navigator.clipboard.writeText(eventUrl);
    alert("Link Copied");
  };

  const handleDelete = async () => {
    const filesToDeleteFromServer = selectedFiles.filter((file) => file.id);
    const filesToRemoveLocally = selectedFiles.filter((file) => !file.id);

    if (filesToDeleteFromServer.length > 0) {
      const idArray = filesToDeleteFromServer.map((file) => file.id);
      deleteFromGallery({ ids: idArray }, setSelectedFiles, () =>
        getAccessGroupGallery(eventGroupId, setFiles)
      );
    }

    if (filesToRemoveLocally.length > 0) {
      setFiles((prevFiles) =>
        prevFiles.filter((file) => !filesToRemoveLocally.includes(file))
      );
    }

    if (
      filesToRemoveLocally.length > 0 &&
      filesToDeleteFromServer.length === 0
    ) {
      setSelectedFiles([]);
    }
  };

  const handleLock = () => {
    const filesToLock = selectedFiles.filter((file) => file.id);

    if (filesToLock.length > 0) {
      const galleryFiles = filesToLock.map((file) => ({
        Id: file.id,
        IsLocked: file.isLocked ? false : true,
      }));

      lockFromGallery({ GalleryFiles: galleryFiles }, () =>
        getAccessGroupGallery(eventGroupId, setFiles)
      );
    }

    setSelectedFiles([]);
  };

  const favoriteClipHandle = (id) => {
    favoriteClip(id, () => getAccessGroupGallery(eventGroupId, setFiles));
  };

  return (
    <div className="container access-gallery px-0">
      <div className="section-header d-block d-md-flex justify-content-between align-items-center px-4 py-2">
        <h6 className="mb-0">{myEventsAccessGallery?.eventName || ""}</h6>
        <p className="p-0 m-0 text">
          <strong className="text">Group Event ID:</strong>{" "}
          {myEventsAccessGallery.id || ""}
        </p>
      </div>
      <div className="px-4 py-2">
        <div className="row my-3">
          <div className="col px-0">
            <p className="p-0 m-0 mb-2 text fw-600 text-dark">
              share this gallery with your guests
            </p>
            <div
              className="col-12 px-0 d-flex align-items-center cursor-pointer"
              onClick={copyToClipboard}
            >
              <p className="mb-0 pr-3 text underline">{eventUrl}</p>
              <img src={copyIcon} alt="" className="ms-2 cursor-pointer" />
            </div>
          </div>
        </div>
      </div>
      {files?.length > 0 ? (
        <div className="px-0 px-md-4 pb-2">
          <ViewGallery
            isAllowLock
            isTabsDisplay
            showHearthIcon
            isModalAllowed
            isAllowDownload
            files={files}
            setFiles={setFiles}
            handleLock={handleLock}
            handleDelete={handleDelete}
            selectedFiles={selectedFiles}
            setSelectedFiles={setSelectedFiles}
            favoriteClipHandle={favoriteClipHandle}
          />
        </div>
      ) : (
        <div className="d-flex justify-content-start mt-4 px-4 access-gallery-fonts">
          <p>{t("no_image")}</p>
        </div>
      )}
    </div>
  );
};

// Mapping the component's props to the reducer's state
const mapStateToProps = (state) => ({
  myEventsAccessGallery: state.customerDashboard.myEventsAccessGallery,
});

// Mapping the component's props to the related actions
const mapDispatchToProps = (dispatch) => ({
  getAccessGroupGallery: (eventGroupId, setFiles) =>
    dispatch(
      customerDashboardActions.getAccessGroupGallery(eventGroupId, setFiles)
    ),
  favoriteClip: (clipId, onSuccess) =>
    dispatch(customerDashboardActions.favoriteClip(clipId, onSuccess)),
  lockFromGallery: (data, onSuccess) =>
    dispatch(customerDashboardActions.lockFromGallery(data, onSuccess)),
  deleteFromGallery: (dataObj, setSelectedFiles, onSuccess) =>
    dispatch(
      customerDashboardActions.deleteFromGallery(
        dataObj,
        setSelectedFiles,
        onSuccess
      )
    ),
});

// mapping action and store the function via props
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(AccessGroupGallery));
